import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntMonthListComponent} from "./int-month-list.component";
import {IntCalendarActionCellModule} from "../action";
import {IntGridContainerModule} from "../../../../containers";
import {IntMonthCellModule} from "../month-cell";

@NgModule({
  imports: [
    CommonModule,
    IntCalendarActionCellModule,
    IntGridContainerModule,
    IntMonthCellModule
  ],
  declarations: [
    IntMonthListComponent
  ],
  exports: [
    IntMonthListComponent
  ]
})
export class IntMonthListModule {}
